import { render, staticRenderFns } from "./ActivityCollaborator.vue?vue&type=template&id=29645070&"
import script from "./ActivityCollaborator.vue?vue&type=script&lang=js&"
export * from "./ActivityCollaborator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports